import { useParams } from "react-router-dom";
import useApi from "../hooks/useApi";
import { getPoliticaBySlug } from "../services/api";
import "./PoliticaDetalle.css";

function PoliticaDetalle() {
  const { slug } = useParams();
  const { data: politica, loading } = useApi(() => getPoliticaBySlug(slug), [slug]);

  if (loading) {
    return (
      <div className="politica-page">
        <div className="politica-wrapper">
          <h1 className="politica-title">Cargando política...</h1>
        </div>
      </div>
    );
  }

  if (!politica || !politica.titulo) {
    return (
      <div className="politica-page">
        <div className="politica-wrapper">
          <h1 className="politica-title">Política no disponible</h1>
          <div className="politica-card">
            <p>
              Todavía no hemos publicado el contenido de esta política. Vuelve pronto o
              contáctanos si tienes preguntas.
            </p>
            <a className="politica-link-home" href="/">
              Volver al inicio
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="politica-page">
      <div className="politica-wrapper">
        <h1 className="politica-title">{politica.titulo}</h1>

        {politica.fecha_actualizacion && (
          <p className="politica-fecha">
            Última actualización: {politica.fecha_actualizacion}
          </p>
        )}

        <div
          className="politica-card"
          dangerouslySetInnerHTML={{ __html: politica.contenido || "" }}
        />
      </div>
    </div>
  );
}

export default PoliticaDetalle;
